function generateUniqueEmail(email: string): string {
  const [localPart, domainPart] = email.split('@');
  const randomNumber = Math.floor(1000 + Math.random() * 9000);
  const uniqueEmail = `${localPart}+${randomNumber}@${domainPart}`;
  return uniqueEmail;
}

export { generateUniqueEmail };
